<style lang="scss">
    @import '~@/abstracts/_variables.scss';

    div#recommended-card-modal {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(0, 0, 0, .6);
        z-index: 99999;

        div.recommended-card-close-block {
            top: 0.5rem;
            right: 0.5rem;
            position: absolute;

            a.recommended-card-close-button {
                justify-content: center;
                align-items: center;
                display: inline-flex;

                border-radius: 0.375rem;
                outline: 2px solid transparent;
                outline-offset: 2px;
                color: rgb(156, 163, 175);
                padding: 0.5rem;

                svg {
                    width: 1.5rem;
                    height: 1.5rem;
                }

                &:hover {
                    background-color: rgb(243, 244, 246);
                    color: rgb(107, 114, 128);
                }
            }
        }

        div.recommended-card-box {
            width: 100%;
            max-width: 530px;
            min-width: 320px;
            padding: 20px;
            background-color: #fff;
            border: 1px solid #ddd;
            border-radius: 0.5rem;
            padding: 1rem;
            box-shadow: 0 0 #000000, 0 0 #000000, 0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -4px rgba(0,0,0,0.1);
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);

            span.recommended-card-label {
                display: block;
                color: black;
                font-family: 'Raleway', sans-serif;
                font-weight: bold;
                text-transform: uppercase;
                text-align: center;
                margin-top: 5px;
                margin-bottom: 5px;
                font-size: 18px;
            }

            p.recommended-card-description {
                color: #666666;
                text-align: center;
                margin-top: 20px;
                font-size: 16px;
            }

            div.recommended-card-images {
                display: flex;
                gap: 5px;
            }
        }
    }

    /* Small only */
    @media screen and (max-width: 39.9375em) {
        div#recommended-card-modal {
            div.recommended-card-box {
                width: 95%;

                span.recommended-card-label {
                    font-size: 15px;
                }

                p.recommended-card-description {
                    font-size: 15px;
                }
            }
        }
    }

    /* Medium only */
    @media screen and (min-width: 40em) and (max-width: 63.9375em) {

    }

    /* Large only */
    @media screen and (min-width: 64em) and (max-width: 74.9375em) {

    }
</style>

<template>
    <div id="recommended-card-modal" v-show="show" v-on:click="show = false">
        <div class="recommended-card-box" v-on:click.stop="">
            <div class="recommended-card-close-block">
                <a v-on:click="show = false" class="recommended-card-close-button">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
                </a>
            </div>

            <div>
                <span class="recommended-card-label">{{ $t('detail.recommendedCardModalTitle') }}</span>

                <p class="recommended-card-description" v-html="$t('detail.recommendedCardModalDescription')"></p>

                <div class="recommended-card-images">
                    <div>
                        <img src="/img/cards/pre-cez-eon-drivalia.png" />
                    </div>
                    <div>
                        <img src="/img/cards/cez-drivalia.png" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { EventBus } from '../../event-bus.js';

    export default {
        data() {
            return {
                show: false
            }
        },

        mounted() {
            EventBus.$on('prompt-recommended-charging-card', function () {
                this.show = true;
            }.bind(this));
        },

        methods: {

        }
    }
</script>
